module.exports = __webpack_public_path__ + "img/branch2.b82e86b7.png";